// import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

// import { useFormik } from 'formik';
// import Select from 'react-select';
// import { Card } from '@components/card/card';
// import { CardBody, Form, InputGroup, Modal } from 'react-bootstrap';
// import { useTranslation } from 'react-i18next';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import Loading from '@components/Shared/Loader/Loading';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import SwalAlert from '@components/Shared/Alert/SwalAlert';
// import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
// import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
// import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
// import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
// import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
// import { useDailyRate } from '@hooks/Finance/DailyRates/useDailyRate';
// import { TreeSelect } from 'antd';
// import { useNavigate, useParams } from 'react-router-dom';
// import { useAppDispatch } from '@store/hooks';
// import { AddPurchaseOrderSchema } from '../../../ValidationForm/validationSchema';
// import POLines from './ReLines';
// import useGetReturnsPurchaseById from '@hooks/PUR/ReturnsPurchase/useGetReturnsPurchaseById';
// import { addReturnsPurchase } from '@store/purchases/ReturnsPurchase/returnsPurchaseSlice';

// const toNum = (v: any) => {
//   const n = Number(v);
//   return Number.isFinite(n) ? n : 0;
// };

// const round2 = (v: any) => {
//   const n = Number(v || 0);
//   return Math.round((n + Number.EPSILON) * 100) / 100;
// };

// const clamp = (n: number, min: number, max: number) => Math.max(min, Math.min(n, max));

// const todayISO = () => new Date().toISOString().split('T')[0];

// // ===============================
// // ✅ حساب سطر (Line) قبل الإرسال
// // ===============================
// const calcLineSnapshot = (line: any) => {
//   const price = round2(toNum(line?.price));
//   const qty = round2(toNum(line?.qty));
//   const vatRate = clamp(round2(toNum(line?.vatRate)), 0, 100);

//   const totalBeforeDiscount = round2(price * qty);

//   const rateVal = clamp(round2(toNum(line?.discountRate)), 0, 100);
//   const amtValRaw = round2(toNum(line?.discountAmount));

//   const mode = String(line?._discountMode || 'RATE');

//   const useAmount = (mode === 'AMOUNT' && amtValRaw > 0) || (mode !== 'RATE' && amtValRaw > 0 && rateVal === 0);

//   let discountApplied = 0;

//   if (useAmount) {
//     discountApplied = clamp(amtValRaw, 0, totalBeforeDiscount);
//   } else {
//     const byRate = round2((totalBeforeDiscount * rateVal) / 100);
//     discountApplied = clamp(byRate, 0, totalBeforeDiscount);
//   }

//   const amountAfterDiscount = round2(totalBeforeDiscount - discountApplied);
//   const vatAmount = round2((amountAfterDiscount * vatRate) / 100);
//   const totalWithVat = round2(amountAfterDiscount + vatAmount);

//   return {
//     vatRate,
//     totalBeforeDiscount,
//     discountApplied,
//     total: amountAfterDiscount, // قبل VAT
//     vatAmount,
//     totalWithVat
//   };
// };

// // =====================================
// // ✅ خصم الهيدر ينعكس على VAT بدقة
// // (نحسب Totals فقط - لا نعدل سطور الإرسال)
// // =====================================
// const calcHeaderTotalsAfterHeaderDiscount = (lines: any[], headerDiscountRate: any, headerDiscountAmount: any) => {
//   const baseSum = round2(lines.reduce((s, l) => s + toNum(l.total), 0)); // مجموع قبل VAT بعد خصم السطور
//   if (baseSum <= 0) {
//     const vatSum0 = round2(lines.reduce((s, l) => s + toNum(l.vatAmount), 0));
//     return { grossAmount: 0, vat: vatSum0, netAmount: round2(vatSum0) };
//   }

//   const hdrAmtRaw = round2(toNum(headerDiscountAmount));
//   const hdrRate = clamp(round2(toNum(headerDiscountRate)), 0, 100);

//   // إن كان amount > 0 نستخدمه، وإلا نستخدم rate
//   const headerDiscountApplied =
//     hdrAmtRaw > 0 ? clamp(hdrAmtRaw, 0, baseSum) : clamp(round2((baseSum * hdrRate) / 100), 0, baseSum);

//   if (headerDiscountApplied <= 0) {
//     const vatSum = round2(lines.reduce((s, l) => s + toNum(l.vatAmount), 0));
//     const net = round2(baseSum + vatSum);
//     return { grossAmount: baseSum, vat: vatSum, netAmount: net };
//   }

//   // توزيع خصم الهيدر على السطور بنسبتها لإعادة حساب VAT بدقة
//   let remainingDisc = headerDiscountApplied;
//   let subtotalAfterHdr = 0;
//   let vatAfterHdr = 0;

//   const lastIdx = lines.length - 1;

//   for (let i = 0; i < lines.length; i++) {
//     const l = lines[i];
//     const base = round2(toNum(l.total));
//     if (base <= 0) continue;

//     const share = i === lastIdx ? remainingDisc : round2((headerDiscountApplied * base) / baseSum);

//     const discLine = clamp(share, 0, base);
//     remainingDisc = round2(remainingDisc - discLine);

//     const newBase = round2(base - discLine);
//     const rate = clamp(round2(toNum(l.vatRate)), 0, 100);
//     const newVat = round2((newBase * rate) / 100);

//     subtotalAfterHdr = round2(subtotalAfterHdr + newBase);
//     vatAfterHdr = round2(vatAfterHdr + newVat);
//   }

//   const netAfterHdr = round2(subtotalAfterHdr + vatAfterHdr);

//   return {
//     grossAmount: subtotalAfterHdr,
//     vat: vatAfterHdr,
//     netAmount: netAfterHdr
//   };
// };

// const AddUpdateReturnsPurchase = () => {
//   // ✅ إلغاء تعدد المخازن نهائيًا (Single Inventory فقط)
//   const { id } = useParams();

//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const navigate = useNavigate();

//   const { Currency, loading: loading4 } = useLookupCurrency();
//   const { PaymentMethodList } = useGetPaymentMethod();

//   const { OperatingUnitOptions, loading: loading7 } = useGetOperatingUnitWithPermission();
//   const { InventoryOptions, loading: loading3 } = useGetInventoryWithPermission();
//   const { treeSuppliersData, SuppliersList, loading: loading2 } = useGetSuppliersList();

//   const { ReturnsPurchaseById: data } = useGetReturnsPurchaseById({ id: id });

//   // ✅ المودال: يظهر فقط إذا ما فيه id
//   const [showSelectionModal, setShowSelectionModal] = useState<boolean>(() => !id);

//   const [selectedOperatingUnit, setSelectedOperatingUnit] = useState<any>(null);
//   const [selectedInventory, setSelectedInventory] = useState<any>(null);

//   // ✅ Refs للـ react-select (للـ focus)
//   const ouSelectRef = useRef<any>(null);
//   const invSelectRef = useRef<any>(null);

//   // ✅ لمنع Enter من التأكيد أثناء فتح قائمة الخيارات
//   const [ouMenuOpen, setOuMenuOpen] = useState(false);
//   const [invMenuOpen, setInvMenuOpen] = useState(false);

//   const defaultToday = useMemo(() => todayISO(), []);

//   // =========================
//   // ✅ initialValues (memo)
//   // =========================
//   const initialValues = useMemo(() => {
//     const lines =
//       data?.transactionsLinesList?.map((item: any) => ({
//         id: item.id,
//         itemType: item.itemType || 'ITEM',
//         itemId: item.itemId,
//         lineNumber: item.lineNumber,
//         uom: item.uom,
//         description: item.description,
//         price: toNum(item.price),
//         qty: toNum(item.qty),
//         discountRate: toNum(item.discountRate),
//         discountAmount: toNum(item.discountAmount),
//         vatRate: toNum(item.vatRate),
//         total: toNum(item.total),
//         vatAmount: toNum(item.vatAmount),
//         inventoryId: item.inventoryId,
//         _discountMode: item?._discountMode || 'RATE'
//       })) || [];

//     return {
//       categoryId: null,

//       organizationId: data?.organizationId ?? '',
//       peopleId: data?.peopleId ?? '',
//       recipientname: data?.recipientname ?? '',
//       billToLocationId: data?.billToLocationId ?? '',
//       shipToLocationId: data?.shipToLocationId ?? '',
//       referenceId: data?.id ?? '',

//       transactionDate: data?.transactionDate ?? defaultToday,
//       deliveryDate: data?.deliveryDate ?? defaultToday,
//       expirationDate: data?.expirationDate ?? '',
//       dueDate: data?.dueDate ?? '',

//       paymentTermsId: data?.paymentTermsId ?? '',
//       paymentMethodId: data?.paymentMethodId ?? '',

//       description: data?.description ?? '',

//       grossAmount: data?.grossAmount ?? '',
//       discountRate: data?.discountRate ?? '',
//       discountAmount: data?.discountAmount ?? '',
//       vat: data?.vat ?? '',
//       netAmount: data?.netAmount ?? '',

//       contractId: data?.contractId ?? '',
//       ameStatus: data?.ameStatus ?? '',
//       personId: data?.personId ?? '',

//       paymentTerms: data?.paymentTerms ?? '',
//       deliveryTerm: data?.deliveryTerm ?? '',

//       inventoryId: data?.inventoryId ?? '', // ✅ مخزن واحد
//       waybill: data?.waybill ?? '',
//       phone: data?.phone ?? '',

//       currencyCode: data?.currencyCode ?? '',
//       currencyConversionRate: data?.currencyConversionRate ?? '',

//       batchId: data?.batchId ?? '',

//       transactionsLinesList: lines
//     };
//   }, [data, defaultToday]);

//   // =========================
//   // ✅ Formik
//   // =========================
//   const formik = useFormik({
//     initialValues,
//     enableReinitialize: true,
//     validationSchema: AddPurchaseOrderSchema(t),
//     onSubmit: values => {
//       const rawLines = values.transactionsLinesList || [];

//       if (!rawLines || rawLines.length === 0) {
//         SwalAlert({ text: 'أدخل أصناف' });
//         formik.setSubmitting(false);
//         return;
//       }

//       // ✅ 1) Normalize lines: إعادة حساب + تثبيت discountAmount الحقيقي + lineNumber
//       const normalizedLines = rawLines.map((l: any, idx: number) => {
//         const snap = calcLineSnapshot(l);

//         return {
//           ...l,
//           lineNumber: idx + 1,

//           _discountAppliedAmount: snap.discountApplied,

//           totalBeforeDiscount: snap.totalBeforeDiscount,
//           total: snap.total,
//           vatRate: snap.vatRate,
//           vatAmount: snap.vatAmount,
//           totalWithVat: snap.totalWithVat,

//           // ✅ نرسل discountAmount = الخصم المعتمد (حتى لو mode=RATE)
//           discountAmount: snap.discountApplied
//         };
//       });

//       // ✅ 2) Header totals: تشمل خصم الهيدر وتعدل VAT بدقة
//       const headerTotals = calcHeaderTotalsAfterHeaderDiscount(
//         normalizedLines,
//         values.discountRate,
//         values.discountAmount
//       );

//       dispatch(
//         addReturnsPurchase({
//           // ✅ إلغاء متعدد المخازن نهائيًا
//           isMultiInventoryFlag: false,
//           inventoryId: values.inventoryId || null,

//           categoryId: null,
//           organizationId: values.organizationId,
//           peopleId: values.peopleId || null,
//           recipientname: values.recipientname,
//           billToLocationId: null,
//           shipToLocationId: null,
//           referenceId: values.referenceId || null,
//           transactionDate: values.transactionDate,
//           deliveryDate: values.deliveryDate || null,
//           expirationDate: values.expirationDate || null,
//           dueDate: values.dueDate || null,
//           paymentTermsId: values.paymentTermsId,
//           paymentMethodId: values.paymentMethodId,
//           description: values.description,

//           // ✅ totals المحسوبة (الأصح للإرسال)
//           grossAmount: headerTotals.grossAmount,
//           discountRate: toNum(values.discountRate),
//           discountAmount: toNum(values.discountAmount),
//           vat: headerTotals.vat,
//           netAmount: headerTotals.netAmount,

//           contractId: values.contractId || null,
//           personId: values.personId || null,
//           paymentTerms: values.paymentTerms,
//           deliveryTerm: values.deliveryTerm,
//           waybill: values.waybill,
//           phone: values.phone,
//           currencyCode: values.currencyCode,

//           currencyConversionRate: toNum(values.currencyConversionRate) || 1,
//           batchId: values.batchId || null,

//           transactionsLinesList: normalizedLines.map((item: any) => ({
//             itemType: item.itemType,
//             itemId: item.itemId || null,
//             lineNumber: item.lineNumber,
//             uom: item.uom,
//             description: item.description,
//             price: toNum(item.price),
//             qty: toNum(item.qty),

//             discountRate: toNum(item.discountRate),
//             discountAmount: toNum(item.discountAmount),
//             vatRate: toNum(item.vatRate),

//             total: toNum(item.total), // قبل VAT (بعد خصم السطر)
//             vatAmount: toNum(item.vatAmount),

//             // ✅ مخزن واحد ثابت من الهيدر
//             inventoryId: values.inventoryId
//           }))
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Add' });
//             navigate('/PUR/ReturnsPurchase', { replace: true });
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch(() => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });

//   const { values, handleChange, errors, touched, setFieldValue, setFieldTouched } = formik;

//   // =========================
//   // ✅ Daily Rate (يتحدث مع تغيير العملة/التاريخ)
//   // =========================
//   const {
//     rate,
//     loading: loadingRate,
//     error: errorRate,
//     refetch
//   } = useDailyRate({
//     currencyCode: values.currencyCode,
//     date: values.transactionDate
//   });

//   // ✅ اربط rate داخل الفورم
//   useEffect(() => {
//     if (!values.currencyCode) {
//       if (toNum(values.currencyConversionRate) !== 1) setFieldValue('currencyConversionRate', 1, false);
//       return;
//     }

//     if (!loadingRate && !errorRate) {
//       const newRate = toNum(rate) || 1;
//       if (toNum(values.currencyConversionRate) !== newRate) {
//         setFieldValue('currencyConversionRate', newRate, false);
//       }
//     }
//   }, [
//     values.currencyCode,
//     values.transactionDate,
//     values.currencyConversionRate,
//     loadingRate,
//     errorRate,
//     rate,
//     setFieldValue
//   ]);

//   // ✅ لو عندنا id و البيانات اكتملت: اخفِ المودال نهائيًا
//   useEffect(() => {
//     if (!id) return;

//     const hasOU = !!data?.organizationId;
//     const hasInv = !!data?.inventoryId; // ✅ دائمًا لازم مخزن

//     if (hasOU && hasInv) setShowSelectionModal(false);
//   }, [id, data?.organizationId, data?.inventoryId]);

//   // ✅ inventory options الخاصة بالـ OU المختارة
//   const invOptionsForSelectedOU = useMemo(() => {
//     return (InventoryOptions || []).filter((x: any) => x.operatingUnitId === selectedOperatingUnit);
//   }, [InventoryOptions, selectedOperatingUnit]);

//   // ✅ اختيار أول OU تلقائيًا (إذا لا يوجد id)
//   useEffect(() => {
//     if (id) return;
//     const firstOU = OperatingUnitOptions?.[0];
//     if (firstOU && !selectedOperatingUnit) setSelectedOperatingUnit(firstOU.value);
//   }, [OperatingUnitOptions, selectedOperatingUnit, id]);

//   // ✅ اختيار أول مخزن تلقائيًا حسب OU (إذا لا يوجد id)
//   useEffect(() => {
//     if (id) return;
//     if (!selectedOperatingUnit) return;

//     const invs = (InventoryOptions || []).filter((x: any) => x.operatingUnitId === selectedOperatingUnit);

//     if (!invs.length) {
//       setSelectedInventory(null);
//       return;
//     }

//     const stillValid = invs.some((x: any) => x.value === selectedInventory);
//     if (!selectedInventory || !stillValid) setSelectedInventory(invs[0]?.value || null);
//   }, [selectedOperatingUnit, InventoryOptions, selectedInventory, id]);

//   // ✅ supplier defaults (بدون سحق اختيار المستخدم)
//   const prevSupplierRef = useRef<any>(null);
//   useEffect(() => {
//     if (!values.peopleId) return;

//     if (prevSupplierRef.current === values.peopleId) return;
//     prevSupplierRef.current = values.peopleId;

//     const supplier = SuppliersList.find((f: any) => f.id === values.peopleId);
//     if (!supplier) return;

//     if (!values.paymentMethodId) {
//       setFieldValue('paymentMethodId', supplier.paymentMethodId, false);
//       setFieldTouched('paymentMethodId', true, false);
//     }

//     if (!values.paymentTermsId) {
//       setFieldValue('paymentTermsId', supplier.termsId, false);
//       setFieldTouched('paymentTermsId', true, false);
//     }

//     if (!values.currencyCode) {
//       setFieldValue('currencyCode', supplier.invoiceCurrencyCode, false);
//       setFieldTouched('currencyCode', true, false);
//     }
//   }, [
//     values.peopleId,
//     values.paymentMethodId,
//     values.paymentTermsId,
//     values.currencyCode,
//     SuppliersList,
//     setFieldValue,
//     setFieldTouched
//   ]);

//   // ✅ confirm modal selection (لازم OU + Inventory دائمًا)
//   const handleSelectionConfirm = useCallback(() => {
//     if (!selectedOperatingUnit || !selectedInventory) return;

//     setFieldValue('organizationId', selectedOperatingUnit, true);
//     setFieldTouched('organizationId', true, false);

//     setFieldValue('inventoryId', selectedInventory, true);
//     setFieldTouched('inventoryId', true, false);

//     setShowSelectionModal(false);
//   }, [selectedOperatingUnit, selectedInventory, setFieldValue, setFieldTouched]);

//   // ✅ فوكس عند فتح المودال
//   useEffect(() => {
//     if (!showSelectionModal) return;

//     const tt = window.setTimeout(() => {
//       ouSelectRef.current?.focus?.();
//     }, 80);

//     return () => window.clearTimeout(tt);
//   }, [showSelectionModal]);

//   // ✅ Enter = استمرار / Esc = إلغاء (مع منع التأكيد إذا القائمة مفتوحة)
//   useEffect(() => {
//     if (!showSelectionModal) return;

//     const onKeyDown = (e: KeyboardEvent) => {
//       if (ouMenuOpen || invMenuOpen) return;

//       if (e.key === 'Enter') {
//         e.preventDefault();
//         const canConfirm = !!selectedOperatingUnit && !!selectedInventory;
//         if (canConfirm) handleSelectionConfirm();
//       }

//       if (e.key === 'Escape') {
//         e.preventDefault();
//         navigate('/PUR/ReturnsPurchase');
//       }
//     };

//     window.addEventListener('keydown', onKeyDown);
//     return () => window.removeEventListener('keydown', onKeyDown);
//   }, [
//     showSelectionModal,
//     ouMenuOpen,
//     invMenuOpen,
//     selectedOperatingUnit,
//     selectedInventory,
//     handleSelectionConfirm,
//     navigate
//   ]);

//   return (
//     <>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             { name: 'Home', link: ':moduleHome' },
//             { name: 'مردودات المشتريات', link: '/PUR/ReturnsPurchase' },
//             { name: 'مردود جديد', link: null }
//           ]}
//           PageName='مردود مشتريات جديد'
//         />
//       </div>

//       <Loading loading={loading2 || loading3 || loading4}>
//         <Form onSubmit={formik.handleSubmit}>
//           <Card className='shadow mb-3'>
//             <CardBody>
//               <div className='row'>
//                 <div className='col-lg-2'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('تـاريخ الأمر')}</label>
//                     <Form.Control
//                       className='form-control  text-center'
//                       type='date'
//                       name='transactionDate'
//                       onChange={handleChange}
//                       value={values.transactionDate || ''}
//                     />
//                     {touched.transactionDate && errors.transactionDate && (
//                       <div className='text-danger'>{errors.transactionDate as any}</div>
//                     )}
//                   </div>
//                 </div>

//                 <div className='col-lg-2'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('تاريخ التسليم')}</label>
//                     <Form.Control
//                       className='form-control  text-center'
//                       type='date'
//                       name='deliveryDate'
//                       onChange={handleChange}
//                       value={values.deliveryDate || ''}
//                       isInvalid={!!(touched.deliveryDate && errors.deliveryDate)}
//                     />
//                     {touched.deliveryDate && errors.deliveryDate && (
//                       <div className='text-danger'>{errors.deliveryDate as any}</div>
//                     )}
//                   </div>
//                 </div>

//                 <div className='col-lg-4'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('الوحدة التشغيليـة')}</label>

//                     <Select
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isLoading={loading3}
//                       isSearchable={true}
//                       isClearable
//                       options={OperatingUnitOptions}
//                       value={OperatingUnitOptions?.find((f: any) => f.value === values.organizationId)}
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                     />

//                     {touched.organizationId && errors.organizationId && (
//                       <div className='text-danger'>{errors.organizationId as any}</div>
//                     )}
//                   </div>
//                 </div>

//                 <div className='col-lg-4'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('المخزن')}</label>
//                     <Select
//                       isDisabled
//                       classNamePrefix='react-select'
//                       isLoading={loading3}
//                       isSearchable
//                       isClearable
//                       options={InventoryOptions?.filter((f: any) => f.operatingUnitId === values.organizationId)}
//                       value={values.inventoryId && InventoryOptions?.find((f: any) => f.value === values.inventoryId)}
//                       placeholder={t('Choose')}
//                     />
//                     {touched.inventoryId && errors.inventoryId && (
//                       <div className='text-danger'>{errors.inventoryId as any}</div>
//                     )}
//                   </div>
//                 </div>

//                 <div className='col-lg-4'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('المورد')}</label>
//                     <TreeSelect
//                       showSearch
//                       className='w-100'
//                       treeLine
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                       allowClear
//                       value={values.peopleId}
//                       onChange={(option: any) => setFieldValue('peopleId', option === null ? null : option)}
//                       treeData={treeSuppliersData}
//                       treeNodeFilterProp='title'
//                     />
//                     {touched.peopleId && errors.peopleId && <div className='text-danger'>{errors.peopleId as any}</div>}
//                   </div>
//                 </div>

//                 <div className='col-xl-4'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('PaymentMethod')}</label>
//                     <Form.Select
//                       className='form-select'
//                       name='paymentMethodId'
//                       onChange={handleChange}
//                       value={values.paymentMethodId}
//                       isInvalid={!!(touched.paymentMethodId && errors.paymentMethodId)}
//                     >
//                       <option key={null} value={''}>
//                         {i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                       </option>
//                       {PaymentMethodList?.map((item: any) => (
//                         <option key={item.id} value={item.id}>
//                           {i18n.language === 'ar' ? item.name2 : item.name}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {touched.paymentMethodId && errors.paymentMethodId && (
//                       <div className='text-danger'>{errors.paymentMethodId as any}</div>
//                     )}
//                   </div>
//                 </div>

//                 <div className='col-lg-2'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'> {t('Currency')} </label>
//                     <Form.Select
//                       className='form-select'
//                       name='currencyCode'
//                       onChange={handleChange}
//                       value={values.currencyCode || ''}
//                       isInvalid={!!(touched.currencyCode && errors.currencyCode)}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>

//                       {Currency?.map((item: any, idx: number) => (
//                         <option key={idx} value={item.currencyCode}>
//                           {item.description}
//                         </option>
//                       ))}
//                     </Form.Select>
//                     {touched.currencyCode && errors.currencyCode && (
//                       <div className='text-danger'>{errors.currencyCode as any}</div>
//                     )}
//                   </div>
//                 </div>

//                 <div className='col-lg-2'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'> {t('CurrencyConversionRate')} </label>
//                     <InputGroup>
//                       <Form.Control
//                         className='form-control text-center'
//                         type='text'
//                         readOnly
//                         value={loadingRate ? '' : errorRate ? 'فشل التحميل' : values.currencyConversionRate}
//                         placeholder={loadingRate ? 'جاري التحميل...' : ''}
//                       />

//                       {loadingRate && (
//                         <InputGroup.Text>
//                           <div className='spinner-border spinner-border-sm text-primary'></div>
//                         </InputGroup.Text>
//                       )}

//                       {errorRate && !loadingRate && (
//                         <InputGroup.Text style={{ padding: '0' }}>
//                           <button
//                             type='button'
//                             className='btn btn-outline-warning h-100 px-2'
//                             onClick={refetch}
//                             title='إعادة تحميل سعر الصرف'
//                           >
//                             <i className='fas fa-redo'></i>
//                           </button>
//                         </InputGroup.Text>
//                       )}
//                     </InputGroup>

//                     {errorRate && !loadingRate && (
//                       <small className='text-warning mt-1 d-block text-center'>
//                         <i className='fas fa-exclamation-circle me-1'></i>
//                         تعذر تحميل السعر
//                         <button type='button' className='btn btn-link btn-sm p-0 text-warning ms-1' onClick={refetch}>
//                           (إعادة المحاولة)
//                         </button>
//                       </small>
//                     )}
//                   </div>
//                 </div>

//                 <div className='col-lg-6'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('الشروط')}</label>
//                     <Form.Control
//                       className='form-control'
//                       as='textarea'
//                       rows={2}
//                       name='paymentTerms'
//                       onChange={handleChange}
//                       value={values.paymentTerms}
//                       isInvalid={!!(touched.paymentTerms && errors.paymentTerms)}
//                     />
//                   </div>
//                 </div>

//                 <div className='col-lg-6'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Note')}</label>
//                     <Form.Control
//                       className='form-control'
//                       as='textarea'
//                       rows={2}
//                       name='description'
//                       onChange={handleChange}
//                       value={values.description}
//                       isInvalid={!!(touched.description && errors.description)}
//                     />
//                   </div>
//                 </div>
//               </div>
//             </CardBody>
//           </Card>

//           <Card className='shadow mb-3'>
//             <POLines formik={formik} isUpdate={!!id} />
//           </Card>

//           <Card className='p-2'>
//             <div className='text-end  '>
//               <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1 rounded-0'>
//                 {formik.isSubmitting ? (
//                   <div className='spinner-border spinner-border-sm me-2'></div>
//                 ) : (
//                   <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
//                 )}
//                 {t('Add')}
//               </button>

//               <button
//                 type='button'
//                 className=' btn btn-lg me-1 btn-default mb-1 rounded-0'
//                 onClick={() => navigate('/PUR/ReturnsPurchase', { replace: true })}
//               >
//                 <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
//               </button>
//             </div>
//           </Card>
//         </Form>
//       </Loading>

//       {/* ✅ Modal يظهر فقط إذا لا يوجد id */}
//       <Modal show={showSelectionModal} backdrop='static' keyboard={false} centered className='modal-selection-theme'>
//         <Modal.Header className='bg-theme bg-opacity-30 text-white py-3'>
//           <Modal.Title className='text-center w-100 h5'>
//             <i className='fas fa-warehouse me-2'></i>
//             {t('اختيار الوحدة التشغيلية والمخزن')}
//           </Modal.Title>
//         </Modal.Header>

//         <Modal.Body className='p-4'>
//           <div className='text-center mb-4'>
//             <div
//               className='bg-inverse bg-opacity-25 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
//               style={{ width: '70px', height: '70px' }}
//             >
//               <i className='fas fa-clipboard-list fs-2 text-theme'></i>
//             </div>
//             <p className='text-muted mb-0'>يجب اختيار الوحدة التشغيلية والمخزن قبل المتابعة</p>
//           </div>

//           <div className='row'>
//             <div className='col-12 mb-4'>
//               <label className='form-label fw-bold'>{t('الوحدة التشغيليـة')}</label>
//               <div className='input-group'>
//                 <span className='input-group-text bg-inverse bg-opacity-25 border-end-0'>
//                   <i className='fas fa-building text-theme'></i>
//                 </span>

//                 <Select
//                   ref={ouSelectRef as any}
//                   classNamePrefix='react-select'
//                   isLoading={loading7}
//                   isSearchable={true}
//                   isClearable
//                   options={OperatingUnitOptions}
//                   value={OperatingUnitOptions?.find((f: any) => f.value === selectedOperatingUnit)}
//                   onMenuOpen={() => setOuMenuOpen(true)}
//                   onMenuClose={() => setOuMenuOpen(false)}
//                   onChange={(option: any) => {
//                     setSelectedOperatingUnit(option?.value || null);
//                     setSelectedInventory(null);

//                     window.setTimeout(() => {
//                       invSelectRef.current?.focus?.();
//                     }, 120);
//                   }}
//                   placeholder={i18n.language === 'ar' ? 'إختر الوحدة التشغيلية' : 'Choose Operating Unit'}
//                   className='flex-grow-1'
//                 />
//               </div>

//               {!selectedOperatingUnit && (
//                 <div className='form-text text-info mt-2'>
//                   <i className='fas fa-info-circle me-1'></i>
//                   اختر الوحدة التشغيلية أولاً لتمكين اختيار المخزن
//                 </div>
//               )}
//             </div>

//             {/* ✅ مخزن واحد دائمًا */}
//             <div className='col-12 mb-3'>
//               <label className='form-label fw-bold'>{t('المخزن')}</label>
//               <div className='input-group'>
//                 <span className='input-group-text bg-inverse bg-opacity-25 border-end-0'>
//                   <i className='fas fa-boxes text-theme'></i>
//                 </span>

//                 <Select
//                   ref={invSelectRef as any}
//                   classNamePrefix='react-select'
//                   isLoading={loading3}
//                   isSearchable
//                   isClearable
//                   options={invOptionsForSelectedOU}
//                   value={selectedInventory && invOptionsForSelectedOU?.find((f: any) => f.value === selectedInventory)}
//                   onMenuOpen={() => setInvMenuOpen(true)}
//                   onMenuClose={() => setInvMenuOpen(false)}
//                   onChange={(option: any) => setSelectedInventory(option?.value || null)}
//                   placeholder={i18n.language === 'ar' ? 'إختر المخزن' : 'Choose Inventory'}
//                   isDisabled={!selectedOperatingUnit}
//                   className='flex-grow-1'
//                 />
//               </div>
//             </div>
//           </div>
//         </Modal.Body>

//         <Modal.Footer className='justify-content-center border-top-0 pt-0'>
//           <button
//             className='btn btn-outline-secondary btn-lg px-4 py-2  me-3'
//             onClick={() => navigate('/PUR/ReturnsPurchase')}
//           >
//             <i className='fas fa-times me-2'></i>
//             {t('إلغاء')}
//           </button>

//           <button
//             className='btn btn-theme btn-lg px-5 py-2 '
//             onClick={handleSelectionConfirm}
//             disabled={!selectedOperatingUnit || !selectedInventory}
//           >
//             <i className='fas fa-check-circle me-2'></i>
//             {t('استمرار')}
//           </button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default AddUpdateReturnsPurchase;

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { useFormik } from 'formik';
import Select from 'react-select';
import { Card } from '@components/card/card';
import { CardBody, Form, InputGroup, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import Loading from '@components/Shared/Loader/Loading';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import useGetPaymentMethod from '@hooks/Payrolls/use-Get-PaymentMethod';
import useGetSuppliersList from '@hooks/NTX/Peoples/useGetSuppliersList';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';
import { useDailyRate } from '@hooks/Finance/DailyRates/useDailyRate';
import { TreeSelect } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch } from '@store/hooks';
import {   AddReturnPurchaseSchema } from '../../../ValidationForm/validationSchema';
import POLines from './ReLines';
import useGetReturnsPurchaseById from '@hooks/PUR/ReturnsPurchase/useGetReturnsPurchaseById';
import { addReturnsPurchase, updateReturnsPurchase } from '@store/purchases/ReturnsPurchase/returnsPurchaseSlice';
import ButtonPrint from '@components/Print/ButtonPrint';

const toNum = (v: any) => {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
};

const round2 = (v: any) => {
  const n = Number(v || 0);
  return Math.round((n + Number.EPSILON) * 100) / 100;
};

const clamp = (n: number, min: number, max: number) => Math.max(min, Math.min(n, max));
const todayISO = () => new Date().toISOString().split('T')[0];

// ===============================
// ✅ حساب سطر (Line) قبل الإرسال
// ===============================
const calcLineSnapshot = (line: any) => {
  const price = round2(toNum(line?.price));
  const qty = round2(toNum(line?.qty));
  const vatRate = clamp(round2(toNum(line?.vatRate)), 0, 100);

  const totalBeforeDiscount = round2(price * qty);

  const rateVal = clamp(round2(toNum(line?.discountRate)), 0, 100);
  const amtValRaw = round2(toNum(line?.discountAmount));

  const mode = String(line?._discountMode || 'RATE');

  const useAmount = (mode === 'AMOUNT' && amtValRaw > 0) || (mode !== 'RATE' && amtValRaw > 0 && rateVal === 0);

  let discountApplied = 0;

  if (useAmount) {
    discountApplied = clamp(amtValRaw, 0, totalBeforeDiscount);
  } else {
    const byRate = round2((totalBeforeDiscount * rateVal) / 100);
    discountApplied = clamp(byRate, 0, totalBeforeDiscount);
  }

  const amountAfterDiscount = round2(totalBeforeDiscount - discountApplied);
  const vatAmount = round2((amountAfterDiscount * vatRate) / 100);
  const totalWithVat = round2(amountAfterDiscount + vatAmount);

  return {
    vatRate,
    totalBeforeDiscount,
    discountApplied,
    total: amountAfterDiscount, // قبل VAT
    vatAmount,
    totalWithVat
  };
};

// =====================================
// ✅ خصم الهيدر ينعكس على VAT بدقة
// (نحسب Totals فقط - لا نعدل سطور الإرسال)
// =====================================
const calcHeaderTotalsAfterHeaderDiscount = (lines: any[], headerDiscountRate: any, headerDiscountAmount: any) => {
  const baseSum = round2(lines.reduce((s, l) => s + toNum(l.total), 0)); // مجموع قبل VAT بعد خصم السطور
  if (baseSum <= 0) {
    const vatSum0 = round2(lines.reduce((s, l) => s + toNum(l.vatAmount), 0));
    return { grossAmount: 0, vat: vatSum0, netAmount: round2(vatSum0) };
  }

  const hdrAmtRaw = round2(toNum(headerDiscountAmount));
  const hdrRate = clamp(round2(toNum(headerDiscountRate)), 0, 100);

  const headerDiscountApplied =
    hdrAmtRaw > 0 ? clamp(hdrAmtRaw, 0, baseSum) : clamp(round2((baseSum * hdrRate) / 100), 0, baseSum);

  if (headerDiscountApplied <= 0) {
    const vatSum = round2(lines.reduce((s, l) => s + toNum(l.vatAmount), 0));
    const net = round2(baseSum + vatSum);
    return { grossAmount: baseSum, vat: vatSum, netAmount: net };
  }

  // توزيع خصم الهيدر على السطور بنسبتها لإعادة حساب VAT بدقة
  let remainingDisc = headerDiscountApplied;
  let subtotalAfterHdr = 0;
  let vatAfterHdr = 0;

  const lastIdx = lines.length - 1;

  for (let i = 0; i < lines.length; i++) {
    const l = lines[i];
    const base = round2(toNum(l.total));
    if (base <= 0) continue;

    const share = i === lastIdx ? remainingDisc : round2((headerDiscountApplied * base) / baseSum);

    const discLine = clamp(share, 0, base);
    remainingDisc = round2(remainingDisc - discLine);

    const newBase = round2(base - discLine);
    const rate = clamp(round2(toNum(l.vatRate)), 0, 100);
    const newVat = round2((newBase * rate) / 100);

    subtotalAfterHdr = round2(subtotalAfterHdr + newBase);
    vatAfterHdr = round2(vatAfterHdr + newVat);
  }

  const netAfterHdr = round2(subtotalAfterHdr + vatAfterHdr);

  return {
    grossAmount: subtotalAfterHdr,
    vat: vatAfterHdr,
    netAmount: netAfterHdr
  };
};

const AddUpdateReturnsPurchase = () => {
  // ✅ Add / Update
  const { id } = useParams();
  const isUpdate = !!id;

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { Currency, loading: loading4 } = useLookupCurrency();
  const { PaymentMethodList } = useGetPaymentMethod();

  const { OperatingUnitOptions, loading: loading7 } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loading3 } = useGetInventoryWithPermission();
  const { treeSuppliersData, SuppliersList, loading: loading2 } = useGetSuppliersList();

  const { ReturnsPurchaseById: data } = useGetReturnsPurchaseById({ id });

  // ✅ المودال: يظهر فقط في الإضافة
  const [showSelectionModal, setShowSelectionModal] = useState<boolean>(() => !id);

  const [selectedOperatingUnit, setSelectedOperatingUnit] = useState<any>(null);
  const [selectedInventory, setSelectedInventory] = useState<any>(null);

  // ✅ Refs للـ react-select (للـ focus)
  const ouSelectRef = useRef<any>(null);
  const invSelectRef = useRef<any>(null);

  // ✅ لمنع Enter من التأكيد أثناء فتح قائمة الخيارات
  const [ouMenuOpen, setOuMenuOpen] = useState(false);
  const [invMenuOpen, setInvMenuOpen] = useState(false);

  const defaultToday = useMemo(() => todayISO(), []);

  // =========================
  // ✅ initialValues (memo)
  // =========================
  const initialValues = useMemo(() => {
    const lines =
      data?.transactionsLinesList?.map((item: any) => ({
        id: item.id,
        itemType: item.itemType || 'ITEM',
        itemId: item.itemId,
        lineNumber: item.lineNumber,
        uom: item.uom,
        description: item.description,
        price: toNum(item.price),
        qty: toNum(item.qty),
        discountRate: toNum(item.discountRate),
        discountAmount: toNum(item.discountAmount),
        vatRate: toNum(item.vatRate),
        total: toNum(item.total),
        vatAmount: toNum(item.vatAmount),
        inventoryId: item.inventoryId,
        _discountMode: item?._discountMode || 'RATE'
      })) || [];

    return {
      categoryId: null,

      organizationId: data?.organizationId ?? '',
      peopleId: data?.peopleId ?? '',
      recipientname: data?.recipientname ?? '',
      billToLocationId: data?.billToLocationId ?? '',
      shipToLocationId: data?.shipToLocationId ?? '',
      referenceId: data?.id ?? '',
      supplierInvoiceNum: data?.supplierInvoiceNum ?? '',

      transactionDate: data?.transactionDate?.split('T')[0] ?? defaultToday,
      deliveryDate: data?.deliveryDate?.split('T')[0] ?? defaultToday,
      expirationDate: data?.expirationDate ?? '',
      dueDate: data?.dueDate ?? '',

      paymentTermsId: data?.paymentTermsId ?? '',
      paymentMethodId: data?.paymentMethodId ?? '',

      description: data?.description ?? '',

      grossAmount: data?.grossAmount ?? '',
      discountRate: data?.discountRate ?? '',
      discountAmount: data?.discountAmount ?? '',
      vat: data?.vat ?? '',
      netAmount: data?.netAmount ?? '',

      contractId: data?.contractId ?? '',
      ameStatus: data?.ameStatus ?? '',
      personId: data?.personId ?? '',

      paymentTerms: data?.paymentTerms ?? '',
      deliveryTerm: data?.deliveryTerm ?? '',

      inventoryId: data?.inventoryId ?? '',
      waybill: data?.waybill ?? '',
      phone: data?.phone ?? '',

      currencyCode: data?.currencyCode ?? '',
      currencyConversionRate: data?.currencyConversionRate ?? '',

      batchId: data?.batchId ?? '',

      transactionsLinesList: lines
    };
  }, [data, defaultToday]);

  // =========================
  // ✅ Formik
  // =========================
  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: AddReturnPurchaseSchema(t),
    onSubmit: values => {
      const rawLines = values.transactionsLinesList || [];

      if (!rawLines || rawLines.length === 0) {
        SwalAlert({ text: 'أدخل أصناف' });
        formik.setSubmitting(false);
        return;
      }

      // ✅ Normalize lines
      const normalizedLines = rawLines.map((l: any, idx: number) => {
        const snap = calcLineSnapshot(l);

        return {
          ...l,
          lineNumber: idx + 1,
          _discountAppliedAmount: snap.discountApplied,
          totalBeforeDiscount: snap.totalBeforeDiscount,
          total: snap.total,
          vatRate: snap.vatRate,
          vatAmount: snap.vatAmount,
          totalWithVat: snap.totalWithVat,
          discountAmount: snap.discountApplied
        };
      });

      // ✅ Header totals
      const headerTotals = calcHeaderTotalsAfterHeaderDiscount(
        normalizedLines,
        values.discountRate,
        values.discountAmount
      );

      // ✅ Payload موحد
      const payload: any = {
        isMultiInventoryFlag: false,
        inventoryId: values.inventoryId || null,

        categoryId: null,
        organizationId: values.organizationId,
        peopleId: values.peopleId || null,
        recipientname: values.recipientname,
        billToLocationId: null,
        shipToLocationId: null,

        supplierInvoiceNum: (values.supplierInvoiceNum || '').trim() || null,

        // ✅ في الإضافة: null ، في التعديل: id
        referenceId: (isUpdate ? id : values.referenceId) || null,

        transactionDate: values.transactionDate,
        deliveryDate: values.deliveryDate || null,
        expirationDate: values.expirationDate || null,
        dueDate: values.dueDate || null,
        paymentTermsId: values.paymentTermsId || null,
        paymentMethodId: values.paymentMethodId || null,
        description: values.description,

        grossAmount: headerTotals.grossAmount,
        discountRate: toNum(values.discountRate),
        discountAmount: toNum(values.discountAmount),
        vat: headerTotals.vat,
        netAmount: headerTotals.netAmount,

        contractId: values.contractId || null,
        personId: values.personId || null,
        paymentTerms: values.paymentTerms,
        deliveryTerm: values.deliveryTerm,
        waybill: values.waybill,
        phone: values.phone,
        currencyCode: values.currencyCode,
        currencyConversionRate: toNum(values.currencyConversionRate) || 1,
        batchId: values.batchId || null,

        transactionsLinesList: normalizedLines.map((item: any) => ({
          id: item.id || null, // ✅ مهم للتعديل (وآمن للإضافة)
          itemType: item.itemType,
          itemId: item.itemId || null,
          lineNumber: item.lineNumber,
          uom: item.uom,
          description: item.description,
          price: toNum(item.price),
          qty: toNum(item.qty),

          discountRate: toNum(item.discountRate),
          discountAmount: toNum(item.discountAmount),
          vatRate: toNum(item.vatRate),

          total: toNum(item.total),
          vatAmount: toNum(item.vatAmount),

          inventoryId: values.inventoryId // ✅ ثابت من الهيدر
        }))
      };

      const thunk = isUpdate
        ? updateReturnsPurchase({ id, ...payload }) // ✅ Update
        : addReturnsPurchase(payload); // ✅ Add

      dispatch(thunk as any)
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: isUpdate ? 'Edit' : 'Add' });
            navigate('/PUR/ReturnsPurchase', { replace: true });
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch(() => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const { values, handleChange, errors, touched, setFieldValue, setFieldTouched } = formik;

  // console.log(errors);

  // =========================
  // ✅ Daily Rate
  // =========================
  const {
    rate,
    loading: loadingRate,
    error: errorRate,
    refetch
  } = useDailyRate({
    currencyCode: values.currencyCode,
    date: values.transactionDate
  });

  useEffect(() => {
    if (!values.currencyCode) {
      if (toNum(values.currencyConversionRate) !== 1) setFieldValue('currencyConversionRate', 1, false);
      return;
    }

    if (!loadingRate && !errorRate) {
      const newRate = toNum(rate) || 1;
      if (toNum(values.currencyConversionRate) !== newRate) {
        setFieldValue('currencyConversionRate', newRate, false);
      }
    }
  }, [
    values.currencyCode,
    values.transactionDate,
    values.currencyConversionRate,
    loadingRate,
    errorRate,
    rate,
    setFieldValue
  ]);

  // ✅ لو عندنا id و البيانات اكتملت: اخفِ المودال نهائيًا
  useEffect(() => {
    if (!id) return;

    const hasOU = !!data?.organizationId;
    const hasInv = !!data?.inventoryId;

    if (hasOU && hasInv) setShowSelectionModal(false);
  }, [id, data?.organizationId, data?.inventoryId]);

  // ✅ inventory options الخاصة بالـ OU المختارة
  const invOptionsForSelectedOU = useMemo(() => {
    return (InventoryOptions || []).filter((x: any) => x.operatingUnitId === selectedOperatingUnit);
  }, [InventoryOptions, selectedOperatingUnit]);

  // ✅ اختيار أول OU تلقائيًا (إذا إضافة)
  useEffect(() => {
    if (id) return;
    const firstOU = OperatingUnitOptions?.[0];
    if (firstOU && !selectedOperatingUnit) setSelectedOperatingUnit(firstOU.value);
  }, [OperatingUnitOptions, selectedOperatingUnit, id]);

  // ✅ اختيار أول مخزن تلقائيًا حسب OU (إذا إضافة)
  useEffect(() => {
    if (id) return;
    if (!selectedOperatingUnit) return;

    const invs = (InventoryOptions || []).filter((x: any) => x.operatingUnitId === selectedOperatingUnit);

    if (!invs.length) {
      setSelectedInventory(null);
      return;
    }

    const stillValid = invs.some((x: any) => x.value === selectedInventory);
    if (!selectedInventory || !stillValid) setSelectedInventory(invs[0]?.value || null);
  }, [selectedOperatingUnit, InventoryOptions, selectedInventory, id]);

  // ✅ supplier defaults (بدون سحق اختيار المستخدم)
  const prevSupplierRef = useRef<any>(null);
  useEffect(() => {
    if (!values.peopleId) return;

    if (prevSupplierRef.current === values.peopleId) return;
    prevSupplierRef.current = values.peopleId;

    const supplier = SuppliersList.find((f: any) => f.id === values.peopleId);
    if (!supplier) return;

    if (!values.paymentMethodId) {
      setFieldValue('paymentMethodId', supplier.paymentMethodId, true);
     }

    if (!values.paymentTermsId) {
      setFieldValue('paymentTermsId', supplier.termsId || null, true);
     }

    if (!values.currencyCode) {
      setFieldValue('currencyCode', supplier.invoiceCurrencyCode, true);
     }
  }, [
    values.peopleId,
    values.paymentMethodId,
    values.paymentTermsId,
    values.currencyCode,
    SuppliersList,
    setFieldValue,
    setFieldTouched
  ]);

  // ✅ confirm modal selection
  const handleSelectionConfirm = useCallback(() => {
    if (!selectedOperatingUnit || !selectedInventory) return;

    setFieldValue('organizationId', selectedOperatingUnit, true);
    setFieldTouched('organizationId', true, false);

    setFieldValue('inventoryId', selectedInventory, true);
    setFieldTouched('inventoryId', true, true);

    setShowSelectionModal(false);
  }, [selectedOperatingUnit, selectedInventory, setFieldValue, setFieldTouched]);

  // ✅ فوكس عند فتح المودال
  useEffect(() => {
    if (!showSelectionModal) return;

    const tt = window.setTimeout(() => {
      ouSelectRef.current?.focus?.();
    }, 80);

    return () => window.clearTimeout(tt);
  }, [showSelectionModal]);

  // ✅ Enter / Esc داخل المودال
  useEffect(() => {
    if (!showSelectionModal) return;

    const onKeyDown = (e: KeyboardEvent) => {
      if (ouMenuOpen || invMenuOpen) return;

      if (e.key === 'Enter') {
        e.preventDefault();
        const canConfirm = !!selectedOperatingUnit && !!selectedInventory;
        if (canConfirm) handleSelectionConfirm();
      }

      if (e.key === 'Escape') {
        e.preventDefault();
        navigate('/PUR/ReturnsPurchase');
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [
    showSelectionModal,
    ouMenuOpen,
    invMenuOpen,
    selectedOperatingUnit,
    selectedInventory,
    handleSelectionConfirm,
    navigate
  ]);

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            { name: 'Home', link: ':moduleHome' },
            { name: 'مردودات المشتريات', link: '/PUR/ReturnsPurchase' },
            { name: isUpdate ? 'تعديل مردود' : 'مردود جديد', link: null }
          ]}
          PageName={isUpdate ? 'تعديل مردود مشتريات' : 'مردود مشتريات جديد'}
        />
        <div className='ms-auto'>
          {isUpdate && (
            <div className='col-5 col-md-6 text-end'>
              <ButtonPrint PrintTemplateTypeId='b9380a29-b3c5-4fe7-9632-805fe34e64f5' ReferenceId={id || ''} />
            </div>
          )}
        </div>
      </div>

      <Loading loading={loading2 || loading3 || loading4}>
        <Form onSubmit={formik.handleSubmit}>
          <Card className='shadow mb-3'>
            <CardBody>
              <div className='row'>
                <div className='col-lg-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('تـاريخ المردود')}</label>
                    <Form.Control
                      className='form-control text-center'
                      type='date'
                      name='transactionDate'
                      onChange={handleChange}
                      value={values.transactionDate || ''}
                    />
                    {touched.transactionDate && errors.transactionDate && (
                      <div className='text-danger'>{errors.transactionDate as any}</div>
                    )}
                  </div>
                </div>

                <div className='col-lg-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('تاريخ التسليم')}</label>
                    <Form.Control
                      className='form-control text-center'
                      type='date'
                      name='deliveryDate'
                      onChange={handleChange}
                      value={values.deliveryDate || ''}
                      isInvalid={!!(touched.deliveryDate && errors.deliveryDate)}
                    />
                    {touched.deliveryDate && errors.deliveryDate && (
                      <div className='text-danger'>{errors.deliveryDate as any}</div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الوحدة التشغيليـة')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading7}
                      isSearchable
                      isClearable
                      options={OperatingUnitOptions}
                      value={OperatingUnitOptions?.find((f: any) => f.value === values.organizationId)}
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    />
                    {touched.organizationId && errors.organizationId && (
                      <div className='text-danger'>{errors.organizationId as any}</div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('المخزن')}</label>
                    <Select
                      isDisabled
                      classNamePrefix='react-select'
                      isLoading={loading3}
                      isSearchable
                      isClearable
                      options={InventoryOptions?.filter((f: any) => f.operatingUnitId === values.organizationId)}
                      value={values.inventoryId && InventoryOptions?.find((f: any) => f.value === values.inventoryId)}
                      placeholder={t('Choose')}
                    />
                    {touched.inventoryId && errors.inventoryId && (
                      <div className='text-danger'>{errors.inventoryId as any}</div>
                    )}
                  </div>
                </div>

                <div className='col-lg-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('المورد')}</label>
                    <TreeSelect
                      showSearch
                      className='w-100'
                      treeLine
                      placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      allowClear
                      value={values.peopleId}
                      onChange={(option: any) => setFieldValue('peopleId', option === null ? null : option)}
                      treeData={treeSuppliersData}
                      treeNodeFilterProp='title'
                    />
                    {touched.peopleId && errors.peopleId && <div className='text-danger'>{errors.peopleId as any}</div>}
                  </div>
                </div>
                {/* <div className='col-lg-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الرقم المرجعي')}</label>
                    <Form.Control
                      className='form-control text-center'
                      type='text'
                      name='supplierInvoiceNum'
                      onChange={handleChange}
                      value={values.supplierInvoiceNum || ''}
                      isInvalid={!!(touched.supplierInvoiceNum && errors.supplierInvoiceNum)}
                      // placeholder={i18n.language === 'ar' ? 'مثال: INV-12345' : 'e.g. INV-12345'}
                    />
                    {touched.supplierInvoiceNum && errors.supplierInvoiceNum && (
                      <div className='text-danger'>{errors.supplierInvoiceNum as any}</div>
                    )}
                  </div>
                </div> */}

                <div className='col-xl-4'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('PaymentMethod')}</label>
                    <Form.Select
                      className='form-select'
                      name='paymentMethodId'
                      onChange={handleChange}
                      value={values.paymentMethodId}
                      isInvalid={!!(touched.paymentMethodId && errors.paymentMethodId)}
                    >
                      <option key={null} value={''}>
                        {i18n.language === 'ar' ? 'إختر' : 'Choose'}
                      </option>
                      {PaymentMethodList?.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {i18n.language === 'ar' ? item.name2 : item.name}
                        </option>
                      ))}
                    </Form.Select>
                    {touched.paymentMethodId && errors.paymentMethodId && (
                      <div className='text-danger'>{errors.paymentMethodId as any}</div>
                    )}
                  </div>
                </div>

                <div className='col-lg-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('Currency')} </label>
                    <Form.Select
                      className='form-select'
                      name='currencyCode'
                      onChange={handleChange}
                      value={values.currencyCode || ''}
                      isInvalid={!!(touched.currencyCode && errors.currencyCode)}
                    >
                      <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                      {Currency?.map((item: any, idx: number) => (
                        <option key={idx} value={item.currencyCode}>
                          {item.description}
                        </option>
                      ))}
                    </Form.Select>
                    {touched.currencyCode && errors.currencyCode && (
                      <div className='text-danger'>{errors.currencyCode as any}</div>
                    )}
                  </div>
                </div>

                <div className='col-lg-2'>
                  <div className='form-group mb-3'>
                    <label className='form-label'> {t('CurrencyConversionRate')} </label>
                    <InputGroup>
                      <Form.Control
                        className='form-control text-center'
                        type='text'
                        readOnly
                        value={loadingRate ? '' : errorRate ? 'فشل التحميل' : values.currencyConversionRate}
                        placeholder={loadingRate ? 'جاري التحميل...' : ''}
                      />

                      {loadingRate && (
                        <InputGroup.Text>
                          <div className='spinner-border spinner-border-sm text-primary'></div>
                        </InputGroup.Text>
                      )}

                      {errorRate && !loadingRate && (
                        <InputGroup.Text style={{ padding: '0' }}>
                          <button
                            type='button'
                            className='btn btn-outline-warning h-100 px-2'
                            onClick={refetch}
                            title='إعادة تحميل سعر الصرف'
                          >
                            <i className='fas fa-redo'></i>
                          </button>
                        </InputGroup.Text>
                      )}
                    </InputGroup>

                    {errorRate && !loadingRate && (
                      <small className='text-warning mt-1 d-block text-center'>
                        <i className='fas fa-exclamation-circle me-1'></i>
                        تعذر تحميل السعر
                        <button type='button' className='btn btn-link btn-sm p-0 text-warning ms-1' onClick={refetch}>
                          (إعادة المحاولة)
                        </button>
                      </small>
                    )}
                  </div>
                </div>

                <div className='col-lg-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('الشروط')}</label>
                    <Form.Control
                      className='form-control'
                      as='textarea'
                      rows={2}
                      name='paymentTerms'
                      onChange={handleChange}
                      value={values.paymentTerms}
                      isInvalid={!!(touched.paymentTerms && errors.paymentTerms)}
                    />
                  </div>
                </div>

                <div className='col-lg-6'>
                  <div className='form-group mb-3'>
                    <label className='form-label'>{t('Note')}</label>
                    <Form.Control
                      className='form-control'
                      as='textarea'
                      rows={2}
                      name='description'
                      onChange={handleChange}
                      value={values.description}
                      isInvalid={!!(touched.description && errors.description)}
                    />
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card className='shadow mb-3'>
            <POLines formik={formik} isUpdate={isUpdate} />
          </Card>

          <Card className='p-2'>
            <div className='text-end'>
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme mb-1 rounded-0'>
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className={`fas fa-lg fa-fw me-2 ${isUpdate ? 'fa-save' : 'fa-plus'}`}></i>
                )}
                {t(isUpdate ? 'Save' : 'Add')}
              </button>

              <button
                type='button'
                className='btn btn-lg me-1 btn-default mb-1 rounded-0'
                onClick={() => navigate('/PUR/ReturnsPurchase', { replace: true })}
              >
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </Card>
        </Form>
      </Loading>

      {/* ✅ Modal (فقط في الإضافة) */}
      <Modal show={showSelectionModal} backdrop='static' keyboard={false} centered className='modal-selection-theme'>
        <Modal.Header className='bg-theme bg-opacity-30 text-white py-3'>
          <Modal.Title className='text-center w-100 h5'>
            <i className='fas fa-warehouse me-2'></i>
            {t('اختيار الوحدة التشغيلية والمخزن')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className='p-4'>
          <div className='text-center mb-4'>
            <div
              className='bg-inverse bg-opacity-25 rounded-circle d-inline-flex align-items-center justify-content-center mb-3'
              style={{ width: '70px', height: '70px' }}
            >
              <i className='fas fa-clipboard-list fs-2 text-theme'></i>
            </div>
            <p className='text-muted mb-0'>يجب اختيار الوحدة التشغيلية والمخزن قبل المتابعة</p>
          </div>

          <div className='row'>
            <div className='col-12 mb-4'>
              <label className='form-label fw-bold'>{t('الوحدة التشغيليـة')}</label>
              <div className='input-group'>
                <span className='input-group-text bg-inverse bg-opacity-25 border-end-0'>
                  <i className='fas fa-building text-theme'></i>
                </span>

                <Select
                  ref={ouSelectRef as any}
                  classNamePrefix='react-select'
                  isLoading={loading7}
                  isSearchable
                  isClearable
                  options={OperatingUnitOptions}
                  value={OperatingUnitOptions?.find((f: any) => f.value === selectedOperatingUnit)}
                  onMenuOpen={() => setOuMenuOpen(true)}
                  onMenuClose={() => setOuMenuOpen(false)}
                  onChange={(option: any) => {
                    setSelectedOperatingUnit(option?.value || null);
                    setSelectedInventory(null);

                    window.setTimeout(() => {
                      invSelectRef.current?.focus?.();
                    }, 120);
                  }}
                  placeholder={i18n.language === 'ar' ? 'إختر الوحدة التشغيلية' : 'Choose Operating Unit'}
                  className='flex-grow-1'
                />
              </div>

              {!selectedOperatingUnit && (
                <div className='form-text text-info mt-2'>
                  <i className='fas fa-info-circle me-1'></i>
                  اختر الوحدة التشغيلية أولاً لتمكين اختيار المخزن
                </div>
              )}
            </div>

            <div className='col-12 mb-3'>
              <label className='form-label fw-bold'>{t('المخزن')}</label>
              <div className='input-group'>
                <span className='input-group-text bg-inverse bg-opacity-25 border-end-0'>
                  <i className='fas fa-boxes text-theme'></i>
                </span>

                <Select
                  ref={invSelectRef as any}
                  classNamePrefix='react-select'
                  isLoading={loading3}
                  isSearchable
                  isClearable
                  options={invOptionsForSelectedOU}
                  value={selectedInventory && invOptionsForSelectedOU?.find((f: any) => f.value === selectedInventory)}
                  onMenuOpen={() => setInvMenuOpen(true)}
                  onMenuClose={() => setInvMenuOpen(false)}
                  onChange={(option: any) => setSelectedInventory(option?.value || null)}
                  placeholder={i18n.language === 'ar' ? 'إختر المخزن' : 'Choose Inventory'}
                  isDisabled={!selectedOperatingUnit}
                  className='flex-grow-1'
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className='justify-content-center border-top-0 pt-0'>
          <button
            className='btn btn-outline-secondary btn-lg px-4 py-2 me-3'
            onClick={() => navigate('/PUR/ReturnsPurchase')}
          >
            <i className='fas fa-times me-2'></i>
            {t('إلغاء')}
          </button>

          <button
            className='btn btn-theme btn-lg px-5 py-2'
            onClick={handleSelectionConfirm}
            disabled={!selectedOperatingUnit || !selectedInventory}
          >
            <i className='fas fa-check-circle me-2'></i>
            {t('استمرار')}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddUpdateReturnsPurchase;
